import graphql from 'babel-plugin-relay/macro';

/**
 * Fragments
 */
export const PAYMENT_IN_INLINE_FRAGMENT = graphql`
  fragment paymentInInlineFragment on PaymentIn @inline {
    id
    externalRef
    ref
    amount
    currencyCode
    payerEmail
    meta
    createdAt
  }
`;

export const PAYMENT_OUTS_PAGINATION_FRAGMENT = graphql`
  fragment paymentOutsPaginationFragment on Query @refetchable(queryName: "PaymentOutsRefetchQuery") {
    paymentOuts(first: $first, after: $after, filter: $filter, ordering: $ordering)
      @connection(key: "PaymentOutsPaginationFragement_paymentOuts") {
      __id
      count
      edges {
        __id
        node {
          id
          createdAt
          externalRef
          accountId
          paymentIn {
            id
            amount
            externalRef
          }
          ref
          salesOrder {
            id
            accountId
            userId
            externalRef
            contact {
              firstName
              lastName
              accountId
            }
            eventGuest {
              contact {
                accountId
                contactAccountId
              }
              externalRef
              event {
                userProfile {
                  firstName
                  lastName
                }
                accountId
              }
            }
          }
          amount
          currencyCode
          meta
          status
          source
        }
      }
    }
  }
`;

export const PAYMENT_BASE_INLINE_FRAGMENT = graphql`
  fragment paymentBaseInlineFragment on Payment @inline {
    id
    paidAt
    amount
    currencyCode
    accountId
    createdAt
    updatedAt
    deletedAt
  }
`;

export const PAYMENT_INLINE_FRAGMENT = graphql`
  fragment paymentInlineFragment on Payment @inline {
    id
    amount
    currencyCode
    accountId
    paidAt
    accountId
    createdAt
    updatedAt
    deletedAt
  }
`;

export const PAYMENTS_PAGINATION_FRAGMENT = graphql`
  fragment paymentsPaginationFragment on Query @refetchable(queryName: "paymentsRefetchableQuery") {
    payments(first: $first, after: $after, ordering: $ordering, filter: $filter)
      @skip(if: $skip)
      @connection(key: "connection_payments") {
      __id
      count
      edges {
        __id
        node {
          ...paymentInlineFragment
        }
      }
    }
  }
`;

/**
 * Queries
 */
export const PAYMENT_OUTS_PAGINATION_QUERY = graphql`
  query paymentOutsPaginationQuery(
    $first: Int!
    $after: String
    $ordering: [PaymentOutOrdering!]
    $filter: PaymentOutFilter
  ) {
    ...paymentOutsPaginationFragment
  }
`;

export const PAYMENTS_PAGINATION_QUERY = graphql`
  query paymentsPaginationQuery(
    $first: Int!
    $after: String
    $ordering: [PaymentOrdering!]
    $filter: PaymentFilter
    $skip: Boolean!
  ) {
    ...paymentsPaginationFragment
  }
`;
